import React, { useContext, useEffect } from 'react'
import PackagedApiClient from '@softwaredev_cegeka/api-client'
import { UserDataContext } from 'src/components/auth/withAuth'
import ApiClient from '@softwaredev_cegeka/api-client'

/**
 * Function used for detecting changes in the auth token and re-rendering the entire page.
 * @param children
 * @returns {JSX.Element}
 * @constructor
 */
export default function AuthTokenUpdater({ children }) {
    const { authToken, impersonatedUser, impersonatedOrganization } =
        useContext(UserDataContext)
    useEffect(() => {
        // Update the authentication token when we are impersonating
        if (impersonatedUser || impersonatedOrganization) {
            ApiClient.setDefaultAuthToken(authToken)
            PackagedApiClient.setDefaultAuthToken(authToken)
        } else {
            // Default to null so the middleware handles the authentication token
            ApiClient.setDefaultAuthToken(null)
            PackagedApiClient.setDefaultAuthToken(null)
        }
    }, [authToken, impersonatedUser, impersonatedOrganization])
    // Force update the entire page re-render, we want to reload everything when an impersonation has happened
    return <React.Fragment key={authToken}>{children}</React.Fragment>
}
